import React from "react";
import GoalCard from "./GoalCard";
import { useDispatch } from "react-redux";
import { removeSelectedGoal, selectGoal } from "../slices/goalsSlice";
import { BrowserRouter as Router } from 'react-router-dom';
import { ONE_GOAL_HELP_TEXT, MORE_GOALS_HELP_TEXT } from "./Constants";

const GoalsList = ({goals, selectedGoals}) => {
    const dispatch = useDispatch();

    const title = (() => {
        if (goals.length === 1 ) {
            return ONE_GOAL_HELP_TEXT;
        } else if (goals.length > 1) {
            return MORE_GOALS_HELP_TEXT;
        } 
    })()

    const select = (id) => {
        dispatch(selectGoal(id))
    }

    const unselect = (id) => {
        dispatch(removeSelectedGoal(id))
    }

    const sortByPriority = (a, b) => {
        const prev = a.priorityOrder;
        const next = b.priorityOrder;
      
        let comparison = 0;
        if (prev > next) {
          comparison = 1;
        } else if (prev < next) {
          comparison = -1;
        }
        return comparison;
    };

    return (goals && goals.length > 0 && <div className="goal-card-list-container">
        <h1>{title}</h1>
        <p>Select how you’d like Distil to help...</p>
        <div className="goal-card-list">
        <Router>
            {goals.sort(sortByPriority).map(g => {
                return <GoalCard
                  key={g.goalId} 
                  text={g.displayTitle} 
                  id={g.goalId} stub={g.stub} 
                  selected={selectedGoals.some(i => i === g.goalId)} 
                  select={select} 
                  unselect={unselect}/>
            })}
        </Router>   
        </div>
    </div>)
};

export default GoalsList;
